<template>
    <div  class="font-roboto">
        <Breadcrumbs main="" :title="$t('lbl_EMPBE_Index')" />
        <div class="container-fluid wrapper">
            Welcome To Admin Panel!
        </div>
        
    </div>
</template>

<script>
export default{

}
</script>

<style>
.wrapper {
  display: flex;
  padding: 32px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 24px;
  background: var(--Surface, #fff);
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.08);
}
</style>